/**
 * Zploštění `GetPlanningTreeResponse` (generovaný read model) pro kalendářový workspace.
 *
 * Stavbu stromu i kolektory termínů drží `venuaPlannerTreeModel` — strom je po sloučení agend
 * jeden a vlastní ho root agenda; kalendáři zbývá jen seznam sérií pro zakládací popover.
 */
import type { GetPlanningTreeResponse } from '@/api/generated/schemas';
import type { CalendarSerieOption } from './components/CreateTermsPopover';

/** Zploštělé série pro select v zakládacím popoveru („Produkt — Série“) */
export function buildCalendarSerieOptions(
  response: GetPlanningTreeResponse
): CalendarSerieOption[] {
  return response.projects.flatMap((project) =>
    project.products.flatMap((product) =>
      product.series
        .filter((serie) => !serie.isArchived)
        .map((serie) => ({
          productId: product.productId,
          serieId: serie.productSerieId,
          label: `${product.name} — ${serie.name}`,
          nights: Math.max(0, serie.mainProgramLengthDays - 1),
        }))
    )
  );
}
